import _ from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../../hooks/hooks";
import { useEffect, useState } from "react";
import { assistancePrograms } from "../../../redux/assistance-programs/action";
import { useSelector } from "react-redux";
import { selectAssistanceProgramsQueryItems } from "../../../redux/assistance-programs/selector";
import { currency } from "../../../common/services/common.service";
import { YesNoRendererComponent } from "../../../common/components/yes-no-renderer.component";
import { InputContainer } from "../../../common/components/form/form.module";
import PageLoader from "../../../components/PageLoader";

export const Subscription = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const queryItems = useSelector(selectAssistanceProgramsQueryItems)
    const [
        selectedAssistanceProgram,
        setSelectedAssistanceProgram
    ] = useState<any>([])

    const [
        subscriptionData,
        setSubscriptionData
    ] = useState<any>([])

    const fetchQueryById = () => {
        dispatch(assistancePrograms.query({
            url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/assistance-programs/query`, entity: 'assistancePrograms', jsonData: {

                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })

    }
    useEffect(
        () => {

            if (isQuery) {
                setSelectedAssistanceProgram(queryItems?.result?.items)


            }
        },
        [isQuery]
    )
    useEffect(
        () => {

            if (parmas?.id > 0) {
                fetchQueryById()
            }

        },
        []
    )


    const handleInnerFormChange: any = (event: any, field: string) => {
        setSubscriptionData({ ...subscriptionData, [field]: event })
    }

    const handleFormSubmit = () => { }

    const Terms = () => {
        navigate(`/terms/${selectedAssistanceProgram?.TermsLibraryId}`)
    }
    return (

        <>
            {isLoading ? <PageLoader /> :
                <div className="container mx-auto px-6 py-16">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Left Section */}
                        <div className="space-y-6">
                            <h1 className="text-base font-semibold text-primary">
                                {selectedAssistanceProgram?.Name}
                            </h1>
                            {selectedAssistanceProgram?.AssistanceProgram && (
                                <div className="flex items-center gap-4 text-sm text-gray-700 mt-2">
                                    <div>Price: {currency(selectedAssistanceProgram?.AssistanceProgram[0]?.Price)}</div>
                                    <span>|</span>
                                    <div>Validity: {selectedAssistanceProgram?.AssistanceProgram[0]?.ProgramDuration}</div>
                                    <span>|</span>
                                    <div>Service Count: {selectedAssistanceProgram?.AssistanceProgram[0]?.NumberOfServiceAnnually}</div>
                                </div>
                            )}
                            {selectedAssistanceProgram?.AssistanceProgram && (<div className="bg-white shadow-md rounded-lg p-4">
                                <div className="divide-y divide-gray-200">
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">Vehicle Type</span>
                                        <span className="text-gray-600">{selectedAssistanceProgram?.AssistanceProgram[0]?.VehicleType}</span>
                                    </div>
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">Coverage Radius</span>
                                        <span className="text-gray-600">{selectedAssistanceProgram?.AssistanceProgram[0]?.CoverageRadius}</span>
                                    </div>
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">Assistance Over Phone</span>
                                        <span className="text-gray-600"><YesNoRendererComponent value={selectedAssistanceProgram?.AssistanceProgram[0]?.IsAssistanceOverPhone} /></span>
                                    </div>
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">Towing</span>
                                        <span className="text-gray-600">{selectedAssistanceProgram?.AssistanceProgram[0]?.Towing}</span>
                                    </div>
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">On-Site Minor Repairs</span>
                                        <span className="text-gray-600"><YesNoRendererComponent value={selectedAssistanceProgram?.AssistanceProgram[0]?.IsOnSiteMinorRepairs} /></span>
                                    </div>
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">Flat Tyre Assistance</span>
                                        <span className="text-gray-600"><YesNoRendererComponent value={selectedAssistanceProgram?.AssistanceProgram[0]?.IsFlatTyreAssistance} /></span>
                                    </div>
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">Locked Key / Lost Key</span>
                                        <span className="text-gray-600"><YesNoRendererComponent value={selectedAssistanceProgram?.AssistanceProgram[0]?.IsLockedKey} /></span>
                                    </div>
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">Battery Support / Jumpstart</span>
                                        <span className="text-gray-600"><YesNoRendererComponent value={selectedAssistanceProgram?.AssistanceProgram[0]?.IsBatterySupport} /> </span>
                                    </div>
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">City Route & Map Guidance</span>
                                        <span className="text-gray-600"><YesNoRendererComponent value={selectedAssistanceProgram?.AssistanceProgram[0]?.IsCityRouteAndMapGuidance} /></span>
                                    </div>
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">Bike Taxi Benefits</span>
                                        <span className="text-gray-600">{selectedAssistanceProgram?.AssistanceProgram[0]?.BikeTaxiBenefits}</span>
                                    </div>
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">Relay On Messages</span>
                                        <span className="text-gray-600"><YesNoRendererComponent value={selectedAssistanceProgram?.AssistanceProgram[0]?.IsRelayOnMessages} /></span>
                                    </div>
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">Medical Coordination</span>
                                        <span className="text-gray-600"><YesNoRendererComponent value={selectedAssistanceProgram?.AssistanceProgram[0]?.IsMedicalCordination} /></span>
                                    </div>
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">Accidental Legal Coordination</span>
                                        <span className="text-gray-600"><YesNoRendererComponent value={selectedAssistanceProgram?.AssistanceProgram[0]?.IsAccidentalLegalCoordination} /></span>
                                    </div>
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">Dedicated 24/7 Helpline</span>
                                        <span className="text-gray-600"><YesNoRendererComponent value={selectedAssistanceProgram?.AssistanceProgram[0]?.IsDedicatedHelpline} /></span>
                                    </div>
                                    <div className="py-2 flex justify-between items-center">
                                        <span className="font-medium text-gray-800">Cooling Period</span>
                                        <span className="text-gray-600">{selectedAssistanceProgram?.AssistanceProgram[0]?.CoolingPeriod}</span>
                                    </div>
                                </div>
                            </div>)}
                        </div>
                        {/* Right Section */}
                        <div className="space-y-2">
                            <h2 className="text-3xl flex justify-center font-semibold text-primary">{selectedAssistanceProgram?.Name}</h2>

                            <div className="flex justify-center">
                                <img
                                    src={selectedAssistanceProgram?.MediaMappings?.MediaFiles[0]?.FileMappingURL || 'https://cdn-icons-png.flaticon.com/512/2052/2052438.png'}
                                    alt={selectedAssistanceProgram?.Name}
                                    className="object-fill bg-skin-thumbnail rounded-lg shadow-md w-40 h-40"
                                />
                            </div>
                            <p className="text-gray-700 flex justify-center leading-relaxed">{selectedAssistanceProgram?.Description}</p>
                            <p className="text-sky-600 cursor-pointer flex justify-center leading-relaxed" onClick={Terms}>view the Terms & Conditions</p>
                            <div className="bg-white shadow-md rounded-lg p-5">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                    <InputContainer

                                        label="Name"

                                        onValueChange={(event: any) => {
                                            handleInnerFormChange(
                                                event.target.value,
                                                'Name'

                                            )
                                        }}
                                        type="text"
                                        value={subscriptionData?.Name}

                                    />

                                    <InputContainer

                                        label="Email"

                                        onValueChange={(event: any) => {
                                            handleInnerFormChange(
                                                event.target.value,
                                                'Email'

                                            )
                                        }}
                                        type="text"
                                        value={subscriptionData?.Email}

                                    />
                                    <InputContainer

                                        label="Phone Number"

                                        onValueChange={(event: any) => {
                                            handleInnerFormChange(
                                                event.target.value,
                                                'PhoneNumber'

                                            )
                                        }}
                                        type="number"
                                        value={subscriptionData?.PhoneNumber}

                                    />
                                    <InputContainer

                                        label="Vehicle Number"

                                        onValueChange={(event: any) => {
                                            handleInnerFormChange(
                                                event.target.value,
                                                'VehicleNumber'

                                            )
                                        }}
                                        type="text"
                                        value={subscriptionData?.VehicleNumber}

                                    />
                                    <InputContainer

                                        label="Vehicle ChassisNumber"

                                        onValueChange={(event: any) => {
                                            handleInnerFormChange(
                                                event.target.value,
                                                'VehicleChassisNumber'

                                            )
                                        }}
                                        type="text"
                                        value={subscriptionData?.VehicleChassisNumber}

                                    />
                                    <InputContainer

                                        label="Vehicle Brand"

                                        onValueChange={(event: any) => {
                                            handleInnerFormChange(
                                                event.target.value,
                                                'VehicleBrand'

                                            )
                                        }}
                                        type="text"
                                        value={subscriptionData?.VehicleBrand}

                                    />
                                    <InputContainer

                                        label="Vehicle Model"

                                        onValueChange={(event: any) => {
                                            handleInnerFormChange(
                                                event.target.value,
                                                'VehicleModel'

                                            )
                                        }}
                                        type="text"
                                        value={subscriptionData?.VehicleModel}

                                    />
                                </div>
                                <div className="pt-3">
                                    <button
                                        type="submit"
                                        onClick={handleFormSubmit}
                                        className="w-full py-3 bg-primary text-light font-semibold rounded-lg shadow-md"
                                    >
                                        Purchase Program
                                    </button>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>}
        </>

    );
};